import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-dots-loading-animation',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './dots-loading-animation.component.html',
    styleUrls: ['./dots-loading-animation.component.scss']
})
export class DotsLoadingAnimationComponent {}
